<template>
    <div class="content-container topiclist">
        <div class="header">
            <div class="header-left title">{{ listTypeDisplay }}</div>
            <div class="header-right pagination">
                <Paginator v-if="pageReady" :pageData="pageData" />
            </div>
        </div>        
        <div class="blocklist-header subtitle columntitles tli">
            <div class="tli-headers">
                <div class="col-status">Status</div>
                <div class="col-topic">Topic</div>
                <div class="col-board">Board</div>
                <div class="col-started-by">Started By</div>
                <div class="col-replies">Replies</div>
                <div class="col-views">Views</div>
                <div class="col-latest">Latest Action</div>
            </div>            
        </div>
        <div class="content nopad" v-if="isAdvancedSearch">                
            <TopicResultItem v-for="topic in advancedSearchTopics" :key="topic.id" :topic="topic"></TopicResultItem>
            <div v-if="!advancedSearchTopics || advancedSearchTopics.length == 0">
                <Loader/>
            </div>             
        </div>
        <div class="content nopad" v-else-if="topicListType=='search'">                
            <TopicResultItem v-for="topic in showedTopics" :key="topic.id" :topic="topic"></TopicResultItem>     
            <div v-if="!showedTopics || showedTopics.length == 0">
                <Loader/>
            </div>            
        </div>
        <div class="content nopad" v-else>                
            <TopicResultItem v-for="topic in topics" :key="topic.id" :topic="topic"></TopicResultItem>             
            <div v-if="!topics || topics.length == 0">
                <Loader/>
            </div>   
        </div>
        <div class="footer">
            <div class="footer-right pagination">
                <Paginator v-if="pageReady" :pageData="pageData" />
            </div>            
        </div>
    </div>
</template>

<script>


    import TopicResultItem from '../../components/Topics/TopicResultItem.vue'
    import Paginator from '../../components/Widgets/Paginator.vue'
    import settings from '../../modules/settings'
    import api from '../../api/api'
    import common from '../../modules/common'
    import Loader from '../../components/Widgets/Loader';

    /*
    topicListType:
        active
        mydiscussions
        unanswered
        new
    */

    export default {

        props: ['topicListType'],

        data() {
            return {
                topics: null,
                pageReady: false,
                pageData: {
                    currentPage: 1,
                    pageSize: 20,
                    totalItems: null,
                    getPage: this.getPage,
                }
            }
        },
        components: { 
            TopicResultItem,
            Paginator,
            Loader
        },
        methods: {
            loadPage: function() {
                
                var bc = common.breadcrumb.create([
                    { url: '/', text: 'UtterAccess' },
                    { url: '/topics/list/' + this.topicListType, text: this.listTypeDisplay }
                ]);

                this.$store.dispatch("breadcrumb", bc);
                this.getPage(1);
            },
            getPage(pageNumber) {

              let pageSize = settings.user.getTopicsPerPage();
                if( this.topicListType != 'search') {
                    this.topics = [];
                    api.get('/topics/list/' + this.topicListType, {
                        params: {
                            listType: this.topicListType,
                            pageSize: pageSize,
                            requestedPage: pageNumber,
                            sortOrder: 'desc'
                        }
                    }).then((response) => {
                        this.topics = response.data
                        this.pageData = {
                            getPage: this.getPage,
                            currentPage: pageNumber,
                            pageSize: pageSize,
                            totalItems: response.data.length > 0 ? response.data[0].totalRows : 0
                        }
                        this.pageData.totalItems = response.data.length > 0 ? response.data[0].totalRows : 0
                        this.pageReady = true;
                        
                    });
                    
                 }
                 else{
              if (this.isAdvancedSearch) {
                  this.$store.commit('setAdvancedSearchedTopics', []);
                api.get('/search/advancedTopicResults', {
                    params: {
                        SearchID: this.$store.state.topic.currentTopicSearchId,
                        pageSize: this.pageData.pageSize,
                        requestedPage: pageNumber,
                        sortOrder: 'asc'
                    }
                }).then((r) => {
                    this.$store.commit('setAdvancedSearchedTopics', r.data);
                    if(r.data.length > 0) {
                        this.pageData.totalItems = r.data[0].totalRows;
                        this.pageReady = true;
                    }
                    
                })
              }
                 }
                 this.pageData.currentPage = pageNumber;
            },
        },
        computed: {
            listTypeDisplay: function () {
                let listType = this.topicListType;
                switch (listType) {
                    case 'mydiscussions': return 'My Discussions';
                    case 'active': return 'Active Topics';
                    case 'unanswered': return 'Unanswered Topics';
                    case 'new': return 'New Topics';
                    case 'search': return 'Search';
                    default: return "";
                }
            },
            searchedTopics: function() {
              const result = [...this.$store.state.topic.searchedTopics]
              if(this.topicListType === 'search'){
                // eslint-disable-next-line
                this.pageData.totalItems = result.length;
              }
              return result;
            },
            isAdvancedSearch: function () {
              return this.$store.state.topic.currentTopicSearchId != null;
            },
            showedTopics() {
              if(this.searchedTopics){
                return this.searchedTopics.slice((this.pageData.currentPage - 1 )* this.pageData.pageSize, (this.pageData.currentPage) * this.pageData.pageSize);
              }
              return [];
            },
            advancedSearchTopics() {
                return [...this.$store.state.topic.advancedSearchTopics];
            },
        },
        watch: {
          searchedTopics (newSearched) {
            if(this.topicListType === 'search') {
              this.topics = newSearched;
              this.pageData.totalItems = this.topics.length;
            }
          },
          isAdvancedSearch (newValue) {
              if (newValue) {
                  this.loadPage();
              }
          }
        },

        beforeRouteUpdate(to, from, next) {
            // handle same-page/different-param route
            this.topicListType = to.params.topicListType;
            this.loadPage();
            next()            
        },
        mounted() {
            this.loadPage();
        },
        beforeDestroy() {
            this.$store.commit('setSearchedIdTopics', null);
            this.$store.commit('setAdvancedSearchedTopics', []);
        }
    }

</script>